import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';
import modifierValue from '../helpers/modifierValue';

Alpine.directive('on-resize', (el, { modifiers, expression }, { Alpine, cleanup, evaluateLater }) => {
    const callback = evaluateLater(expression)

    if (typeof callback !== 'function') {
        return console.error('The given expression is not a function', el);
    }

    const targetModifier = modifierValue(modifiers, 'target', null);

    const target = targetModifier ? document.querySelector([`[x-ref="${targetModifier}"]`]) : el;

    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            if (entry.contentRect.height > 0 || entry.contentRect.width > 0) {
                callback();
            }
        });
    });

    Alpine.nextTick(() => {
        resizeObserver.observe(target);
    })

    window.addEventListener('loading', function({ detail }) {
        const { loading } = detail

        if (loading) {
            return;
        }

        callback();
    })

    cleanup(() => {
        resizeObserver.disconnect();
    })
})
